import { i18n } from "../../../translate/i18n";
import { NodeWrapper } from "./NodeWrapper";
import { EventAvailableOutlined } from '@mui/icons-material';
import React, { memo } from "react";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";
import { mkHeaderStyle, HEADER_ICON_STYLE, HEADER_TEXT_STYLE, NODE_BODY_STYLE, NODE_INFO_ROW, mkInputHandleStyle } from "./nodeStyles";

import { Tooltip as CoreTooltip, IconButton as CoreIconButton } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#1e293b',
    color: '#f8fafc',
    maxWidth: 380,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #334155',
    padding: '12px 14px',
    borderRadius: '8px',
    fontFamily: "'Inter', 'Roboto', sans-serif",
    lineHeight: 1.5,
  },
  arrow: { color: '#1e293b' },
}))(CoreTooltip);

const useStyles = makeStyles((theme) => ({
  pulseIcon: {
    color: '#ffffff',
    borderRadius: '50%',
    animation: '$glowPulse 1.5s infinite',
  },
  '@keyframes glowPulse': {
    '0%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0.9)' },
    '70%': { boxShadow: '0 0 0 8px rgba(255, 255, 255, 0)' },
    '100%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' },
  },
}));


export default memo(({ data, isConnectable, id, selected }) => {
  const classes = useStyles();

  return (
    <NodeWrapper id={id} selected={selected} color="#06B6D4">
      <Handle type="target" position="left" style={mkInputHandleStyle("#06B6D4")} isConnectable={isConnectable} />
      
      <div style={mkHeaderStyle("#06B6D4")}>
        <EventAvailableOutlined style={HEADER_ICON_STYLE} />
        <div style={HEADER_TEXT_STYLE}>{data.name || "Agendamiento"}</div>
      
        <HtmlTooltip
          arrow
          title={
            <React.Fragment>
              <div style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', color: '#22d3ee' }}>
                💡 {i18n.t("flowBuilder.tooltips.scheduling.title")}
              </div>
              <div style={{ marginBottom: '0' }}>
                <div dangerouslySetInnerHTML={{ __html: i18n.t("flowBuilder.tooltips.scheduling.body") }} />
              </div>
            </React.Fragment>
          }
          placement="right"
        >
          <CoreIconButton size="small" style={{ padding: '4px', marginLeft: '2px' }} className={classes.pulseIcon}>
            <HelpOutlineIcon style={{ fontSize: '15px' }} />
          </CoreIconButton>
        </HtmlTooltip>
      </div>
      
      <div style={NODE_BODY_STYLE}>
        <div style={{ ...NODE_INFO_ROW, position: "relative" }}>
          <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {data.category ? `Servicio: ${data.category}` : "Seleccione un servicio"}
          </div>
          
          <Handle 
            type="source" 
            position="right" 
            id="a" 
            style={{ 
              position: "absolute",
              background: "#06B6D4", 
              width: "10px", 
              height: "20px", 
              borderRadius: "4px", 
              cursor: "pointer", 
              border: "2px solid white", 
              top: "50%", 
              transform: "translateY(-50%)", 
              right: -25 
            }} 
            isConnectable={isConnectable} 
          />
        </div>
      </div>
    </NodeWrapper>
  );
});
